<template>
    <div class="shopact">
        <van-nav-bar :title="data.title"/>
        <van-panel title="" desc="" status="">
            <van-cell-group>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">门店名称</span>
                        <span class="label-content">{{ data.shop_data.shop_name }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">活动时间</span>
                        <span class="label-content">{{ data.package_card_data.begin_date }}至{{ data.package_card_data.end_date }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">门店位置</span>
                        <span class="label-content">{{ data.shop_data.shop_address }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">联系电话</span>
                        <span class="label-content">{{ data.shop_data.shop_phone }} {{ data.shop_data.shop_contact_phone }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">购买套餐</span>
                        <span class="label-content">{{ data.package_name }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">套餐内容</span>
                    </template>
                    <template slot="label">
                        <van-tag v-for="(itm, rowidx) in data.package_card_data.servers" :key="rowidx" round type="success">
                            {{ itm['name'] + '[' + itm['qty'] + ']'}}
                        </van-tag>
                        <van-tag v-for="(itm, rowidx) in data.package_card_data.versions" :key="rowidx" round type="success">
                            {{ itm['name'] + '[' + itm['qty'] + ']'}}
                        </van-tag>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-panel>
        <ToShare ref="toshare" />
    </div>
</template>

<script>
import { 
    NavBar,
    Panel, 
    CellGroup,
    Cell,
    Icon,
    Tag,
    Loading, 
} from 'vant'

import { ShopActItemApi } from '@/api/shopact'
import ToShare from '@/view/components/toshare'
import wxshare from '@/utils/wxshare'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Panel.name]: Panel,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Loading.name]: Loading,
        [Image.name]: Image,
        [Icon.name]: Icon,
        [Tag.name]: Tag,
        ToShare
    },
    data() {
        return {
            data: {
                amount: '',
                create_date: '',
                id: null,
                package_card: null,
                package_card_data: {
                    begin_date: '',
                    end_date: '',
                    id: '',
                    servers: [],
                    versions: []
                },
                package_name: '',
                pay_date: '',
                pay_state: 0,
                pay_state_name: '',
                shared_id: '',
                shop_activity: null,
                shop_data: {
                    shop_address: '',
                    shop_contact_name: '',
                    shop_contact_phone: '',
                    shop_name: '',
                    shop_phone: ''
                },
                shop_img: '',
                title: '',
                vip_name: '',
                vip_phone: '',
                vipmember_info: null
            },
            loading: false
        }
    },
    mounted() {
        this.data.id = this.$route.params.id,
        // this.postData.shop_activity = this.data.id
        this.getData(this.data.id)
        this.getVipInfo()
    },
    methods: {
        getData(id) {
            var that = this
            that.loading = true
            this.axios.get(ShopActItemApi + id + '/').then((ret) => {
                that.loading = false
                that.data = ret
                console.log(ret)

                wxshare.shareItem(`您的好友正在分享${that.data.title}`, 
                    that.data.act_rem, 
                    that.data.shop_img, 
                    `${window.location.origin}/#/nt/activities/shopact/${this.data.shop_activity}/?uid=uid` )
                // console.log('应该出现分享菜单了')
            })
        },
        getVipInfo() {
            // var that = this
            // that.axios.get(VipApi).then((ret) => {
            //     console.log('huiyuanxinxi')
            //     console.log(ret)
            //     if (ret.flag) {
            //         let vipCarCode = ret.details.car_code
            //         that.postData.phone = ret.details.vip_phone
            //         that.postData.car_code = vipCarCode
            //         that.postData.nick_name = ret.details.user_name
            //         if (vipCarCode.length > 0) {
            //             that.area_name = vipCarCode.substring(0, 1)
            //             that.code = vipCarCode.substring(1)
            //         }
            //     }
            // })
        },
        onShare() {
            this.$refs.toshare.show()
        }
    }
}
</script>

<style lang="less">
.van-button--danger {
    margin-left: 60px;
}
</style>

<style lang="less" scoped>
.shopact {
    img {
        width: 100%;
    }
    .label-title {
        font-weight: bold;
        margin-right: 8px;
    }
    .label-content {
        
    }
    .van-tag {
        margin-right: 4px;
    }
}
</style>